export default __webpack_public_path__ + "static/media/3.df0591bc.svg";